import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

const StoreName = ({ isLoading }) => (
	<FormItem label="sc.storeName" isLoading={isLoading} required>
		<StringInput name="storeName" placeholder="enterStoreName" />
	</FormItem>
);

export default StoreName;
